import { render } from "./AdvertisementModerationExternal.vue?vue&type=template&id=7087d8ba&scoped=true"
import script from "./AdvertisementModerationExternal.vue?vue&type=script&lang=js"
export * from "./AdvertisementModerationExternal.vue?vue&type=script&lang=js"

import "./AdvertisementModerationExternal.vue?vue&type=style&index=0&id=7087d8ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7087d8ba"]])

export default __exports__